<tui-root>
  <div class="router-outlet-container">
    <router-outlet />
  </div>
</tui-root>
